module.exports = __webpack_public_path__ + "hyperion-v2-static/img/hotspots_big_selected.e63778cc.png";